module.exports = __webpack_public_path__ + "media/access/cert-89c02727.png";